import { createFileRoute, Outlet, useMatch } from "@tanstack/react-router";
import { AdminClientsPage } from "@/pages/admin-clients/ui/admin-clients-page";
import { searchParams } from "@/pages/admin-clients/model/search-params";
import { Suspense } from "react";
import { DetailViewSkeleton } from "@/shared/ui/detail-view-skeleton";

const ClientsLayout = () => {
  const detailMatch = useMatch({
    from: "/_authed/$companySlug/admin/clients/$clientId",
    shouldThrow: false,
  });

  if (detailMatch) {
    return (
      <Suspense fallback={<DetailViewSkeleton />}>
        <Outlet />
      </Suspense>
    );
  }

  return <AdminClientsPage />;
};

export const Route = createFileRoute("/_authed/$companySlug/admin/clients")({
  component: ClientsLayout,
  validateSearch: searchParams,
});
